module.exports = __webpack_public_path__ + "img/harrison-logo.1b03eda9.jpg";